import Pristine from "pristinejs";
import domready from "domready";
import Flatpickr from "flatpickr";

const lang = document.documentElement.lang.slice(0, 2) || 'de';
Pristine.setLocale(lang);

Pristine.addMessages('en', {
  date: "${0} is not a valid date.",
  "date-min": "You must select a date after ${1}.",
  "date-max": "You must select a date before ${1}."
})

Pristine.addMessages('de', {
  required: "Der angegebene Wert ist leer",
  email: "Dieses Feld benötigt eine gültige E-Mail-Adresse",
  number: "Dieses Feld benötigt eine Zahl",
  url: "Dieses Feld benötigt eine gültige URL",
  tel: "Dieses Feld benötigt eine gültige Telefonnummer",
  maxlength: "Geben Sie weniger als ${1} Zeichen ein",
  minlength: "Geben Sie mehr als ${1} Zeichen ein",
  min: "Der Minimalwert für dieses Feld beträgt ${1}",
  max: "Der Maximalwert für dieses Feld beträgt ${1}",
  pattern: "Ihre Eingabe muss dem Muster ${1} entsprechen",
  equals: "Die Felder stimmen nicht überein",
  date: "${0} ist kein gültiges Datum",
  "date-min": "Sie müssen ein Datum nach dem ${1} wählen",
  "date-max": "Sie müssen ein Datum vor dem ${1} wählen"
})

/**
 * When a user submits a form we should validate it
 *    If validation fails, show errors and scroll to first error on page
 *    If validation passes, continue sending form
 *
 * @param event {SubmitEvent}
 */
function handleFormSubmit(event) {
  // event.preventDefault()  // THIS NEEDS TO BE REMOVED SO WE CAN SUBMIT THE FORM. USED ONLY FOR DEBUGGING!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  const submitter = event.submitter != null
    ? event.submitter
    : document.activeElement;

  const form = submitter.closest('form');

  if (!Object.prototype.hasOwnProperty.call(form, 'pristine')) {
    return;
  }

  const pristine = form.pristine;
  const skipValidation = submitter && submitter.hasAttribute('formnovalidate');

  if (skipValidation !== true && !pristine.validate()) {
    event.preventDefault();
    scrollToError('.input-group--has-error');
  } else {
    const submitButtons = event.target.querySelectorAll('[type="submit"]');
    window.requestAnimationFrame(() => {
      for (let i in submitButtons) {
        if (submitButtons.hasOwnProperty(i)) {
          submitButtons[i].disabled = true;
        }
      }
    });
  }
}

/**
 * @param {string} errorElementSelector
 * @return void
 */
function scrollToError(errorElementSelector) {
  const errorElement = document.querySelector(errorElementSelector);
  if (errorElement) {
    const bodyRect = document.body.getBoundingClientRect();
    const errorElementRect = errorElement.getBoundingClientRect();
    const offset = errorElementRect.top - bodyRect.top;

    const topbarHeight = document.querySelector('.top-bar').clientHeight;
    window.scrollTo({ top: (offset - topbarHeight), behavior: 'smooth' });
  }
}

function addHtml5CompatiblePatternValidation(Pristine) {
  Pristine.addValidator('pattern', function(val, pattern) {
    var patternParts = pattern.match(new RegExp('^/\\^?(.*?)\\$?/([gimy]*)$'));
    var matcher;
    if (patternParts !== null) {
      matcher = new RegExp('^(?:' + patternParts[1] + ')$', patternParts[2]);
    } else {
      matcher = new RegExp('^(?:' + pattern + ')$');
    }
    return !val || matcher.test(val);
  });
}

/**
 * Add custom validation to the advanced password input.
 * We should always compare if both password inputs are exactly the same
 *
 * @param passElement
 * @param pristine
 */
function addAdvancedPassValidation(passElement, pristine) {
  pristine.addValidator(passElement, function(value) {
    var confirmationValue = '';

    if (passElement.classList.contains('input--password-origin')) {
      confirmationValue = passElement.closest('.input-group').querySelector('.input--password-confirmation').value;
    } else if (passElement.classList.contains('input--password-confirmation')) {
      confirmationValue = passElement.closest('.input-group').querySelector('.input--password-origin').value;
    }

    return value === confirmationValue;

  }, {
    en: "The entered passwords do not match!",
    de: "Die eingegebenen Passwörter sind nicht identisch!",
  });
}


/**
 * Add custom validation to the multi-checkbox
 * When a checkbox is clicked we need to check if the amount of checked options in the groups is inside the given range
 *
 * @param multiCheckElement
 * @param pristine
 */
function addAMultiCheckboxValidation(multiCheckElement, pristine) {
  var min = multiCheckElement.getAttribute('data-multi-checkbox-min') || 0;
  var max = multiCheckElement.getAttribute('data-multi-checkbox-max') || Number.POSITIVE_INFINITY;

  pristine.addValidator(multiCheckElement, function() {
    var totalGroupChecks = 0;
    var groupChecks = multiCheckElement.closest('.input-group--multi-check').querySelectorAll('.checkbox');

    for (var i = 0; i < groupChecks.length; i++) {
      if (groupChecks[i].checked) {
        totalGroupChecks++;
      }
    }

    return totalGroupChecks >= min && totalGroupChecks <= max;

  }, {
    en: `You must check between ${min} and ${max} options!`,
    de: `Bitte wählen Sie ${min} bis ${max} Optionen aus!`,
  })
}



/**
 * Add custom validation to the multi-select
 * If the multi-select has a min and max value, we should check if the selected amount is inside the desired range
 *
 * @param multiSelectElement
 * @param pristine
 */
function addAMultiSelectValidation(multiSelectElement, pristine) {
  var min = multiSelectElement.getAttribute('data-multi-select-min') || 0;
  var max = multiSelectElement.getAttribute('data-multi-select-max') || Number.POSITIVE_INFINITY;

  pristine.addValidator(multiSelectElement, function() {
    var totalSelectedOptions = 0;

    for (var i = 0; i < multiSelectElement.options.length; i++) {
      if (multiSelectElement.options[i].selected) {
        totalSelectedOptions++;
      }
    }

    return totalSelectedOptions >= min && totalSelectedOptions <= max;
  }, {
    en: `You must select between ${min} and ${max} options!`,
    de: `Bitte wählen Sie ${min} bis ${max} Optionen aus!`,
  });
}

function addDateValidation(Pristine) {

  function parseDate(date, format) {
    const formatArray = (format || 'Y-m-d').split(/[\/\-\.]/);
    const dateArray = date.split(/[\/\-\.]/);

    if (dateArray.length !== 3 || formatArray.length !== 3) {
      return false;
    }

    let year = null;
    let month = null;
    let day = null;
    formatArray.forEach((key, index) => {
      switch (key) {
        case 'Y':
          year = parseInt(dateArray[index]);
          if (year < 1000 || year > 9999) {
            year = null;
          }
          break;
        case 'm':
          month = parseInt(dateArray[index]) - 1;
          if (month < 0 || month > 11) {
            month = null;
          }
          break;
        case 'd':
          day = parseInt(dateArray[index]);
          if (day < 0 || day > 31) {
            day = null;
          }
          break;
      }
    });

    if (year === null || month === null || day === null) {
      return false;
    }

    try {
      return Date.UTC(year, month, day);
    } catch (e) {
      return false;
    }
  }

  Pristine.addValidator('date', function(val, displayFormat) {
    const date = parseDate(val, displayFormat);
    return date !== false;
  }, null, 65, true);

  Pristine.addValidator('date-min', function(val, min, displayFormat) {
    const date = parseDate(val, displayFormat);

    if (date === false) {
      return false;
    }

    const minDate = parseDate(min, displayFormat);
    return !(minDate !== false && minDate > date);
  }, null, 61, true);

  Pristine.addValidator('date-max', function(val, max, displayFormat) {
    const date = parseDate(val, displayFormat);

    if (date === false) {
      return false;
    }

    const maxDate = parseDate(max, displayFormat);
    return !(maxDate !== false && date > maxDate);
  }, null, 60, true);
}

addHtml5CompatiblePatternValidation(Pristine);
addDateValidation(Pristine);

function handleFormUpdateInputsToValidate() {
  const formElements = document.querySelectorAll('.form');
  formElements.forEach((formElement) => {
    if (formElement.pristine) {
      formElement.pristine.reset();
      formElement.pristine.destroy();
    }
  });

  initFormValidation();
}

function initFormValidation() {
  // Get all forms on the current page
  const formElements = document.querySelectorAll('.form');

  // Pristine configuration object
  const pristineConfig = {
    classTo: "input-group",
    errorClass: "input-group--has-error",
    successClass: "input-group--has-success",
    errorTextParent: "input-group",
    errorTextTag: "span",
    errorTextClass: "form__error"
  };


  formElements.forEach(formElement => {
    const pristine = new Pristine(formElement, pristineConfig);
    const passConfirmationInputs = formElement.querySelectorAll(".input--advanced-password");
    if (passConfirmationInputs) {
      passConfirmationInputs.forEach(passConfirmationInput => {
        // eslint-disable-next-line no-use-before-define
        addAdvancedPassValidation(passConfirmationInput, pristine);
      });
    }
    const multipleChecks = formElement.querySelectorAll(".input-group--multi-check .checkbox");
    if (multipleChecks) {
      multipleChecks.forEach(multiCheck => {
        if (multiCheck.getAttribute("data-multi-checkbox-min") || multiCheck.getAttribute("data-multi-checkbox-max")) {
          // eslint-disable-next-line no-use-before-define
          addAMultiCheckboxValidation(multiCheck, pristine);
        }
      });
    }
    const multiSelects = formElement.querySelectorAll(".multi-select");
    if (multiSelects) {
      multiSelects.forEach(multiSelect => {
        if (multiSelect.getAttribute("data-multi-select-min") || multiSelect.getAttribute("data-multi-select-max")) {
          // eslint-disable-next-line no-use-before-define
          addAMultiSelectValidation(multiSelect, pristine);
        }
      });
    }

    formElement.pristine = pristine;

    // Remove inputs that are disabled or hidden from the validation
    formElement.pristine.fields = formElement.pristine.fields.filter((input) => {
      return !input.input.disabled && input.input.type !== "hidden"
    });

    formElement.dispatchEvent(new CustomEvent('pristine-ready'));

    formElement.removeEventListener('submit', handleFormSubmit);
    formElement.addEventListener('submit', handleFormSubmit);
  });
}

window.addEventListener('toujou-form-update-inputs-to-validate', handleFormUpdateInputsToValidate);

domready(() => {
  initFormValidation();
  document.addEventListener('toujou-form-init', initFormValidation);
});
